import React from 'react'
import { useTranslation } from 'react-i18next'
import useRoutes from '../../state/useRoutes'
import { Link, useParams } from 'react-router-dom'
import { useNavigate, useOutletContext } from 'react-router'
import EventDateAttendeesList from './EventDateAttendeesList'

export default React.memo(function EventDateAttendeesListPage() {
  const { close } = useOutletContext<any>()
  const navigate = useNavigate()
  const { fromPath } = useParams()

  const onClose = () => {
    if (fromPath) {
      // The attendee list was opened from a different page = a learning path page.
      // So we should navigate back to that page
      navigate(-1)
    }

    close()
  }

  return <EventDateAttendeesList onClose={onClose} />
})

export function EventDateAttendeesListPageBreadcrumb() {
  const { t } = useTranslation()
  const routes = useRoutes()
  const { uuid, eventUuid, dateUuid } = useParams()

  return (
    <Link
      to={routes.manageCourseEventDateAttendees.url({
        uuid: uuid!,
        eventUuid: eventUuid!,
        dateUuid: dateUuid!,
        fromPath: null,
      })}
    >
      {t('learning item.scheduled course participants')}
    </Link>
  )
}
